module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-profile/user-profile.component.scss
// module id = ./src/app/components/user-profile/user-profile.component.scss
// module chunks = main